import { IRatingHistoryModel } from 'entities/competitions-b2b';
import { ICompetitionSalesPointRatingStatsWidgetFlow } from '../../types';

const useSalesPointGenerateLineChart = (
  data: IRatingHistoryModel[] | undefined,
  flow: ICompetitionSalesPointRatingStatsWidgetFlow,
) => {
  if (!data || !data.length) {
    return {
      xAxis: [],
      series: [],
    };
  }

  switch (flow) {
    case ICompetitionSalesPointRatingStatsWidgetFlow.purchases:
      return {
        xAxis: [{ data: data.map((item) => item.competition_day) }],
        series: [{ data: data.map((item) => item.purchase_amount_today) }],
      };
  }

  return {
    xAxis: [{ data: data.map((item) => item.competition_day) }],
    series: [{ data: data.map((item) => item.place) }],
  };
};

export { useSalesPointGenerateLineChart };
